module.exports = __webpack_public_path__ + "img/abc-logo.f2fb0bfb.jpg";